
import React from 'react'
import PropTypes from 'prop-types'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'

const LanguageSelect = ({disabled, languages, onChange, value, ...rest}) => (
  <Select
    disabled={disabled}
    onChange={evt => onChange(evt.target.value)}
    value={value}
    {...rest}
  >
    {languages.map(lang => (
      <MenuItem
        key={lang.languageId}
        value={lang.languageCode}
      >
        {lang.languageName}
      </MenuItem>
    ))}
  </Select>
)

LanguageSelect.propTypes = {
  disabled: PropTypes.bool,
  languages: PropTypes.arrayOf(
    PropTypes.shape({
      languageCode: PropTypes.string,
      languageId: PropTypes.number,
      languageName: PropTypes.string
    })
  ).isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string
}

LanguageSelect.defaultProps = {
  disabled: false
}

export default LanguageSelect



// WEBPACK FOOTER //
// ./src/components/language/LanguageSelect.js